export default {
  title: 'Ohrmarken',
  categories: 'Kategorien',
  createdAt: 'Erstellt am',
  createdFrom: 'Erstellt von',
  category: 'Kategorie',
  defaultPrices: "Preise",
  defaultPrice: "Preis",
  packageFee: "Paketpauschale",
  invoiceNumber: "Rechnungsnummer",
  invoiceDate: "Rechnungsdatum",
  collectionDate: "Einzugsdatum",
  defaultPriceDescription: 'Der Preis wird aus dem Standard Ohrmarken Preis geladen',
  number: 'Anzahl',
  pen: 'Stift',
  toOrder: 'Bestellen',
  orders: 'Bestellungen',
  openOrders: 'Offene Bestellungen',
  doneOrders: 'Getätigte Bestellungen',
  orderNumber: "Bestell-Nr.",
  currentNumber: 'lfd. Nr.',
  orderDate: "Datum",
  thornPart: "Dornteil",
  thornPartColor: "Dornteilfarbe",
  holePart: "Lochteil",
  holePartColor: "Lochteilfarbe",
  takeOrder: "Bestellung auslösen",
  account: 'Verrechnung erstellen',
  elba: 'ELBA erstellen',
  download: {
    addressList: "Adressliste herunterladen",
    orderList: "Bestellungen herungerladen"
  },
  notification: {
    save: {
      type: 'success',
      message: 'Ohrmarke erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    saveDefaultPrice: {
      type: 'success',
      message: 'Ohrmarke Standardpreis erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    order: {
      type: 'success',
      message: 'Ohrmake erfolgreich bestellt',
      title: 'Erfolgreich bestellt'
    },
    orderSet: {
      type: 'success',
      message: 'Bestellung erfolgreich erstellt',
      title: 'Erfolgreich bestellt'
    }
  }
}
